import { useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Fade,
} from '@mui/material';
import { darken } from '@mui/material/styles';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 360,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  height: 215,
};

const OtpModal = ({ open, handleClose, handleSubmit, length, message, resetMsg }) => {
  const [otp, setOtp] = useState('');

  const resetMsgStr = () => {
     if(message && typeof resetMsg === 'function') {
      resetMsg('')
    }
  }

  const handleChange = (e) => {
    const value = e.target.value;
    resetMsgStr()
    if ((length === 6 && /^\d{0,6}$/.test(value)) || (length === 4 && /^\d{0,4}$/.test(value))) setOtp(value);
  };

  const onSubmit = () => {
    handleSubmit(otp);
  };

  const onCancel = () => {
    handleClose();
    setOtp('');
    resetMsgStr('');
  };

  return (
    <Modal
      open={open}
      onClose={onCancel}
      closeAfterTransition
      sx={{ zIndex: 99999, backdropFilter: 'blur(4px)', outline: 'none' }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Typography variant="h6" fontWeight="bold" mb={2}>
            Enter OTP
          </Typography>
          <TextField
            label={`${length}-digit OTP`}
            fullWidth
            value={otp}
            onChange={handleChange}
            inputProps={{ maxLength: length, inputMode: 'numeric' }}
            sx={{ mb: 3, }}
            error={!!message}
            helperText={message ? message : ''}
          />
          <Box display="flex" justifyContent="flex-end" gap={2}>
            <Button onClick={onCancel}>Cancel</Button>
            <Button
              variant="contained"
              onClick={onSubmit}
              disabled={otp.length !== length}
              sx={{
               backgroundColor: '#182bda',
              '&:hover': {
                backgroundColor: darken('#182bda', 0.5),
              },
              }}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default OtpModal;